import {
    POST_ORDER_DETAILS_TO_NATIVE,
    POST_CANCEL_ORDER_DETAILS_OCP_TO_NATIVE,
} from '../actionTypes/NativeOrderConfirmationActionTypes';

export const postOrderDetailsToNative = () => ({
    type: POST_ORDER_DETAILS_TO_NATIVE,
});

export const postCancelOrderDetailsToNative = (payload) => ({
    type: POST_CANCEL_ORDER_DETAILS_OCP_TO_NATIVE,
    payload: {
        data: {
            orderNumber: payload,
        },
    },
});

export default { postOrderDetailsToNative, postCancelOrderDetailsToNative };
